function MobileShare(props) {
  const handleShareClick = () => {
    if (typeof navigator !== "undefined" && navigator.share) {
      navigator
        .share({
          title: `${props.title || ""},`,
          text: `${props.text || ""},`,
          url: `${props.url || ""},`,
        })
        .then(() => {
          console.log("Successfully shared");
        })
        .catch((err) => {
          console.error("Something went wrong while sharing", err);
        });
    }
  };

  return (
    <div className="share-button">
      <img
        src="../assets/images/icons/Share-Icon.png"
        alt=""
        className="img-fluid mx-auto d-block"
        onClick={handleShareClick}
      />
    </div>
  );
}

export default MobileShare;
